module.exports = __webpack_public_path__ + "static/media/panco_01.f1948cf9.jpg";